import { ACTION_PREFIX } from '../../helpers/constants';

export const INBOX_VIEW_DETECTED = `${ACTION_PREFIX}/INBOX_VIEW_DETECTED`;

export const inboxViewDetected = () => ({
  type: INBOX_VIEW_DETECTED,
});
